import { Pipe, PipeTransform } from '@angular/core';
import { TipoSignificadoRubricaProvedorConciliacaoFatura as Tipo } from '../../models/conferencia-de-fatura/TipoSignificadoRubricaProvedorConciliacaoFatura';

@Pipe({
  name: 'tipoSignificadoRubrica',
})
export class TipoSignificadoRubricaPipe implements PipeTransform {
  transform(value: Tipo): string {
    return {
      [Tipo.Mensalidade]: 'Mensalidade',
      [Tipo.Coparticipacao]: 'Coparticipação',
      [Tipo.TaxaImplantacao]: 'Taxa de Implantação',
      [Tipo.InclusaoRetroativa]: 'Inclusão Retroativa',
      [Tipo.ExclusaoRetroativa]: 'Exclusão Retroativa',
      [Tipo.Indefinido]: 'Indefinido',
      [Tipo.Desconto]: 'Desconto',
      [Tipo.Adicional]: 'Adicional',
    }[value];
  }
}
